<template>
  <div>
    <v-container class="action-container">
      <v-row no-gutters>
        <v-col cols="1"></v-col>
        <v-col
          cols="9"
          md="8"
          lg="6"
          class="text-h6 text-md-h5 text-lg-h5 font-weight-bold"
        >
          <div>Reinstate confirmation</div>
        </v-col>
        <v-col cols="2" md="3" lg="5" class="text-right">
          <slot name="reinstateClose"></slot>
        </v-col>
      </v-row>

      <v-row no-gutters class="mb-2">
        <v-col cols="1"></v-col>
        <v-col cols="10" md="10" lg="10" class="font-weight-bold">
          <div>
            <v-icon color="#F1B300" small class="mr-2"
              >fa-solid fa-triangle-exclamation</v-icon
            >
            Are you sure you would like to reinstate the selected certificate?
          </div>
        </v-col>
      </v-row>

      <v-row no-gutters class="mb-2">
        <v-col cols="1"></v-col>
        <v-col cols="11" md="11" lg="10">
          <div>
            Reinstating a certificate will remove it from the CRL (Certificate Revocation
            List) and change its state to "Active".
          </div>
        </v-col>
      </v-row>

      <v-row no-gutters>
        <v-col cols="5" md="7" lg="7"> </v-col>
        <slot name="reinstateButton"></slot>
      </v-row>
      <v-row class="text-center">
        <slot name="pendingReinstate"></slot>
      </v-row>
    </v-container>
  </div>
</template>
<script>
export default {
  props: ["iconText", "breadText"],
  data() {
    return {};
  },
  methods: {},
};
</script>
<style></style>
